





















































import Vue from "vue";
import {
  IncorrectInventoryPayLoadType,
  ErrorTrackingIncorrectInventory
} from "../models/ErrorTrackingIncorrectInventory";
import IncorrectInventoryTable from "../components/IncorrectInventoryTable.vue";
export default Vue.extend({
  components: {
    IncorrectInventoryTable
  },
  data() {
    const isLoading = false;
    const errorTrackingIncorrectInventory: ErrorTrackingIncorrectInventory = {
      id: 0,
      startCheckingDate: "",
      endCheckingDate: "",
      payload: []
    };
    const incorrectInventoryPayLoadType: IncorrectInventoryPayLoadType = {
      products: [],
      boxs: [],
      gift: []
    };

    return {
      isLoading,
      errorTrackingIncorrectInventory,
      incorrectInventoryPayLoadType
    };
  },
  async created() {
    this.isLoading = true;
    await this.getIncorrectInventoryById(+this.$route.params.id);
    this.incorrectInventoryPresenter();
    this.isLoading = false;
  },
  methods: {
    async getIncorrectInventoryById(id: number) {
      try {
        const {
          data
        } = await (this as any).$dep.errorTrackingUseCase.getIncorrectInventoryById(
          id
        );
        this.errorTrackingIncorrectInventory = data;
      } catch (error) {
        console.log(error);
      }
    },
    incorrectInventoryPresenter() {
      try {
        this.incorrectInventoryPayLoadType = (this as any).$dep.errorTrackingUseCase.incorrectInventoryPresenter(
          this.errorTrackingIncorrectInventory.payload
        );
      } catch (error) {
        console.log(error);
      }
    },
    goToIncorrectInventoryViewPage() {
      this.$router.push({ name: "ErrorTrackingIncorrectInventoryViewPage" });
    }
  }
});
